//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.6.3.0 (NJsonSchema v11.5.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* eslint-disable */
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');

export interface IPromotionsClient {
    /**
     * Parsear un archivo de asociaciones de promoción (flujo en línea)
     * @param file (optional) 
     */
    parseAssociationsFile(file?: FileParameter | undefined): Observable<ParseAssociationsFileResponseDto>;
    /**
     * Resolver un lote de IDs de asociaciones contra el catálogo
     */
    resolveAssociations(body: ResolveAssociationsRequestDto): Observable<ResolveAssociationsResponseDto>;
    /**
     * Finalizar una promoción
     * @return Promoción finalizada exitosamente
     */
    finishPromotion(id: string, body: PromotionFinishDto): Observable<void>;
    /**
     * Listar items en la cola de promociones
     * @param q (optional) Texto de búsqueda libre. Busca coincidencias parciales en code, name y description.
     * @param id (optional) Filtra por el identificador único interno de la promoción (búsqueda exacta).
     * @param status (optional) Filtra por uno o más estados de promoción.
     * @param types (optional) Filtra por uno o más tipos de beneficio.
     * @param page (optional) Número de página (base 0).
     * @param size (optional) Cantidad de elementos por página.
     * @param sort (optional) Criterio de ordenamiento con formato propiedad,dirección. Por defecto: createdDate,desc.
     */
    getPromotions(q?: string | undefined, id?: string | undefined, status?: Status[] | undefined, types?: Types[] | undefined, page?: number | undefined, size?: number | undefined, sort?: string[] | undefined): Observable<PromotionsResponseDto>;
    /**
     * Crear una nueva promoción
     */
    createPromotion(body: PromotionCreateDto): Observable<PromotionCreateResponseDto>;
    /**
     * Obtener detalle de una promoción
     */
    getPromotionDetail(id: string): Observable<PromotionDetailDto>;
    /**
     * Actualizar una promoción existente
     */
    updatePromotion(id: string, body: PromotionUpdateDto): Observable<PromotionUpdateDto>;
}

@Injectable({
    providedIn: 'root'
})
export class PromotionsClient implements IPromotionsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Parsear un archivo de asociaciones de promoción (flujo en línea)
     * @param file (optional) 
     */
    parseAssociationsFile(file?: FileParameter | undefined): Observable<ParseAssociationsFileResponseDto> {
        let url_ = this.baseUrl + "/hub/management/promotions/v1/associations/parse-file";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file === null || file === undefined)
            throw new globalThis.Error("The parameter 'file' cannot be null.");
        else
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processParseAssociationsFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processParseAssociationsFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ParseAssociationsFileResponseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ParseAssociationsFileResponseDto>;
        }));
    }

    protected processParseAssociationsFile(response: HttpResponseBase): Observable<ParseAssociationsFileResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ParseAssociationsFileResponseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Archivo faltante, formato no soportado o sin columna ID", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Resolver un lote de IDs de asociaciones contra el catálogo
     */
    resolveAssociations(body: ResolveAssociationsRequestDto): Observable<ResolveAssociationsResponseDto> {
        let url_ = this.baseUrl + "/hub/management/promotions/v1/associations/resolve";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processResolveAssociations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResolveAssociations(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResolveAssociationsResponseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResolveAssociationsResponseDto>;
        }));
    }

    protected processResolveAssociations(response: HttpResponseBase): Observable<ResolveAssociationsResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResolveAssociationsResponseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Finalizar una promoción
     * @return Promoción finalizada exitosamente
     */
    finishPromotion(id: string, body: PromotionFinishDto): Observable<void> {
        let url_ = this.baseUrl + "/hub/management/promotions/v1/{id}/finish";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFinishPromotion(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFinishPromotion(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processFinishPromotion(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Listar items en la cola de promociones
     * @param q (optional) Texto de búsqueda libre. Busca coincidencias parciales en code, name y description.
     * @param id (optional) Filtra por el identificador único interno de la promoción (búsqueda exacta).
     * @param status (optional) Filtra por uno o más estados de promoción.
     * @param types (optional) Filtra por uno o más tipos de beneficio.
     * @param page (optional) Número de página (base 0).
     * @param size (optional) Cantidad de elementos por página.
     * @param sort (optional) Criterio de ordenamiento con formato propiedad,dirección. Por defecto: createdDate,desc.
     */
    getPromotions(q?: string | undefined, id?: string | undefined, status?: Status[] | undefined, types?: Types[] | undefined, page?: number | undefined, size?: number | undefined, sort?: string[] | undefined): Observable<PromotionsResponseDto> {
        let url_ = this.baseUrl + "/hub/management/promotions/v1?";
        if (q === null)
            throw new globalThis.Error("The parameter 'q' cannot be null.");
        else if (q !== undefined)
            url_ += "q=" + encodeURIComponent("" + q) + "&";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (status === null)
            throw new globalThis.Error("The parameter 'status' cannot be null.");
        else if (status !== undefined)
            status && status.forEach(item => { url_ += "status=" + encodeURIComponent("" + item) + "&"; });
        if (types === null)
            throw new globalThis.Error("The parameter 'types' cannot be null.");
        else if (types !== undefined)
            types && types.forEach(item => { url_ += "types=" + encodeURIComponent("" + item) + "&"; });
        if (page === null)
            throw new globalThis.Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (size === null)
            throw new globalThis.Error("The parameter 'size' cannot be null.");
        else if (size !== undefined)
            url_ += "size=" + encodeURIComponent("" + size) + "&";
        if (sort === null)
            throw new globalThis.Error("The parameter 'sort' cannot be null.");
        else if (sort !== undefined)
            sort && sort.forEach(item => { url_ += "sort=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPromotions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPromotions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PromotionsResponseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PromotionsResponseDto>;
        }));
    }

    protected processGetPromotions(response: HttpResponseBase): Observable<PromotionsResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PromotionsResponseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Crear una nueva promoción
     */
    createPromotion(body: PromotionCreateDto): Observable<PromotionCreateResponseDto> {
        let url_ = this.baseUrl + "/hub/management/promotions/v1";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreatePromotion(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreatePromotion(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PromotionCreateResponseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PromotionCreateResponseDto>;
        }));
    }

    protected processCreatePromotion(response: HttpResponseBase): Observable<PromotionCreateResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PromotionCreateResponseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Obtener detalle de una promoción
     */
    getPromotionDetail(id: string): Observable<PromotionDetailDto> {
        let url_ = this.baseUrl + "/hub/management/promotions/v1/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPromotionDetail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPromotionDetail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PromotionDetailDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PromotionDetailDto>;
        }));
    }

    protected processGetPromotionDetail(response: HttpResponseBase): Observable<PromotionDetailDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PromotionDetailDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Actualizar una promoción existente
     */
    updatePromotion(id: string, body: PromotionUpdateDto): Observable<PromotionUpdateDto> {
        let url_ = this.baseUrl + "/hub/management/promotions/v1/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdatePromotion(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdatePromotion(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PromotionUpdateDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PromotionUpdateDto>;
        }));
    }

    protected processUpdatePromotion(response: HttpResponseBase): Observable<PromotionUpdateDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PromotionUpdateDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export class ParseAssociationsFileResponseDto implements IParseAssociationsFileResponseDto {
    /** IDs leídos del archivo, deduplicados y en orden de aparición. Vacío si el archivo supera maxIds (truncated=true). */
    ids!: string[];
    /** Cantidad total de filas de datos leídas (incluye las que fallaron). */
    totalRows!: number;
    /** Cantidad de IDs duplicados descartados dentro del archivo. */
    duplicateCount!: number;
    /** true cuando el archivo supera el máximo de IDs para el flujo en línea. En ese caso ids viene vacío y el cliente debe derivar la carga al flujo de import job. */
    truncated!: boolean;
    /** Primeros IDs del archivo (máx. 50), disponibles aun con truncated=true. Permiten sembrar la condición al crear la promoción antes del import job (el micro exige al menos una condición y el job la reemplaza por la lista completa). */
    previewIds!: string[];
    /** Máximo de IDs aceptado por el flujo en línea (config del servidor). */
    maxIds!: number;
    /** Filas que no se pudieron leer. */
    errors!: ParsedAssociationRowErrorDto[];

    [key: string]: any;

    constructor(data?: IParseAssociationsFileResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.ids = [];
            this.previewIds = [];
            this.errors = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["ids"])) {
                this.ids = [] as any;
                for (let item of _data["ids"])
                    this.ids!.push(item);
            }
            this.totalRows = _data["totalRows"];
            this.duplicateCount = _data["duplicateCount"];
            this.truncated = _data["truncated"];
            if (Array.isArray(_data["previewIds"])) {
                this.previewIds = [] as any;
                for (let item of _data["previewIds"])
                    this.previewIds!.push(item);
            }
            this.maxIds = _data["maxIds"];
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(ParsedAssociationRowErrorDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ParseAssociationsFileResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new ParseAssociationsFileResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.ids)) {
            data["ids"] = [];
            for (let item of this.ids)
                data["ids"].push(item);
        }
        data["totalRows"] = this.totalRows;
        data["duplicateCount"] = this.duplicateCount;
        data["truncated"] = this.truncated;
        if (Array.isArray(this.previewIds)) {
            data["previewIds"] = [];
            for (let item of this.previewIds)
                data["previewIds"].push(item);
        }
        data["maxIds"] = this.maxIds;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IParseAssociationsFileResponseDto {
    /** IDs leídos del archivo, deduplicados y en orden de aparición. Vacío si el archivo supera maxIds (truncated=true). */
    ids: string[];
    /** Cantidad total de filas de datos leídas (incluye las que fallaron). */
    totalRows: number;
    /** Cantidad de IDs duplicados descartados dentro del archivo. */
    duplicateCount: number;
    /** true cuando el archivo supera el máximo de IDs para el flujo en línea. En ese caso ids viene vacío y el cliente debe derivar la carga al flujo de import job. */
    truncated: boolean;
    /** Primeros IDs del archivo (máx. 50), disponibles aun con truncated=true. Permiten sembrar la condición al crear la promoción antes del import job (el micro exige al menos una condición y el job la reemplaza por la lista completa). */
    previewIds: string[];
    /** Máximo de IDs aceptado por el flujo en línea (config del servidor). */
    maxIds: number;
    /** Filas que no se pudieron leer. */
    errors: ParsedAssociationRowErrorDto[];

    [key: string]: any;
}

export class ResolveAssociationsRequestDto implements IResolveAssociationsRequestDto {
    /** Store a la que pertenecen las entidades a resolver. */
    storeId!: string;
    entityType!: ResolveAssociationsRequestDtoEntityType;
    /** IDs a resolver contra el catálogo. Máximo 500 por llamada. */
    ids!: string[];

    [key: string]: any;

    constructor(data?: IResolveAssociationsRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.ids = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.storeId = _data["storeId"];
            this.entityType = _data["entityType"];
            if (Array.isArray(_data["ids"])) {
                this.ids = [] as any;
                for (let item of _data["ids"])
                    this.ids!.push(item);
            }
        }
    }

    static fromJS(data: any): ResolveAssociationsRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResolveAssociationsRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["storeId"] = this.storeId;
        data["entityType"] = this.entityType;
        if (Array.isArray(this.ids)) {
            data["ids"] = [];
            for (let item of this.ids)
                data["ids"].push(item);
        }
        return data;
    }
}

export interface IResolveAssociationsRequestDto {
    /** Store a la que pertenecen las entidades a resolver. */
    storeId: string;
    entityType: ResolveAssociationsRequestDtoEntityType;
    /** IDs a resolver contra el catálogo. Máximo 500 por llamada. */
    ids: string[];

    [key: string]: any;
}

export class ResolveAssociationsResponseDto implements IResolveAssociationsResponseDto {
    /** Entidades resueltas, en el orden del request. */
    resolved!: ResolvedAssociationDto[];
    errors!: ResolveAssociationErrorDto[];

    [key: string]: any;

    constructor(data?: IResolveAssociationsResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.resolved = [];
            this.errors = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["resolved"])) {
                this.resolved = [] as any;
                for (let item of _data["resolved"])
                    this.resolved!.push(ResolvedAssociationDto.fromJS(item));
            }
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(ResolveAssociationErrorDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResolveAssociationsResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResolveAssociationsResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.resolved)) {
            data["resolved"] = [];
            for (let item of this.resolved)
                data["resolved"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IResolveAssociationsResponseDto {
    /** Entidades resueltas, en el orden del request. */
    resolved: ResolvedAssociationDto[];
    errors: ResolveAssociationErrorDto[];

    [key: string]: any;
}

export class PromotionFinishDto implements IPromotionFinishDto {
    /** Motivo por el cual se finaliza la promoción. */
    reason!: PromotionFinishDtoReason;

    [key: string]: any;

    constructor(data?: IPromotionFinishDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.reason = _data["reason"];
        }
    }

    static fromJS(data: any): PromotionFinishDto {
        data = typeof data === 'object' ? data : {};
        let result = new PromotionFinishDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["reason"] = this.reason;
        return data;
    }
}

export interface IPromotionFinishDto {
    /** Motivo por el cual se finaliza la promoción. */
    reason: PromotionFinishDtoReason;

    [key: string]: any;
}

export class PromotionsResponseDto implements IPromotionsResponseDto {
    content!: PromotionDto[];
    pageable!: PageableDto;
    totalPages!: number;
    totalElements!: number;
    last!: boolean;
    size!: number;
    number!: number;
    numberOfElements!: number;
    first!: boolean;
    empty!: boolean;
    sort!: SortDto;

    [key: string]: any;

    constructor(data?: IPromotionsResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.content = [];
            this.pageable = new PageableDto();
            this.sort = new SortDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["content"])) {
                this.content = [] as any;
                for (let item of _data["content"])
                    this.content!.push(PromotionDto.fromJS(item));
            }
            this.pageable = _data["pageable"] ? PageableDto.fromJS(_data["pageable"]) : new PageableDto();
            this.totalPages = _data["totalPages"];
            this.totalElements = _data["totalElements"];
            this.last = _data["last"];
            this.size = _data["size"];
            this.number = _data["number"];
            this.numberOfElements = _data["numberOfElements"];
            this.first = _data["first"];
            this.empty = _data["empty"];
            this.sort = _data["sort"] ? SortDto.fromJS(_data["sort"]) : new SortDto();
        }
    }

    static fromJS(data: any): PromotionsResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new PromotionsResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.content)) {
            data["content"] = [];
            for (let item of this.content)
                data["content"].push(item ? item.toJSON() : undefined as any);
        }
        data["pageable"] = this.pageable ? this.pageable.toJSON() : undefined as any;
        data["totalPages"] = this.totalPages;
        data["totalElements"] = this.totalElements;
        data["last"] = this.last;
        data["size"] = this.size;
        data["number"] = this.number;
        data["numberOfElements"] = this.numberOfElements;
        data["first"] = this.first;
        data["empty"] = this.empty;
        data["sort"] = this.sort ? this.sort.toJSON() : undefined as any;
        return data;
    }
}

export interface IPromotionsResponseDto {
    content: PromotionDto[];
    pageable: PageableDto;
    totalPages: number;
    totalElements: number;
    last: boolean;
    size: number;
    number: number;
    numberOfElements: number;
    first: boolean;
    empty: boolean;
    sort: SortDto;

    [key: string]: any;
}

export class PromotionCreateDto implements IPromotionCreateDto {
    /** Código único de la promoción. */
    code!: string;
    /** Nombre descriptivo de la promoción. */
    name!: string;
    /** Descripción detallada de la promoción para el cliente. */
    description?: string;
    /** Indica si la promoción puede combinarse con otras promociones. */
    isStackable!: boolean;
    /** Moneda soportada por el sistema. */
    currencyCode!: string;
    /** Número máximo de veces que la promoción puede ser usada globalmente. */
    maxUses?: number;
    /** Número máximo de veces que un cliente puede usar esta promoción. */
    maxUsesPerCustomer?: number;
    /** Calendario de vigencia de la promoción. */
    schedule!: PromotionScheduleDto;
    /** Condiciones de elegibilidad de la promoción. */
    conditions!: Conditions;
    /** Configuración del beneficio de la promoción. */
    benefit?: Benefit;

    [key: string]: any;

    constructor(data?: IPromotionCreateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.schedule = new PromotionScheduleDto();
            this.conditions = new Conditions();
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.code = _data["code"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.isStackable = _data["isStackable"];
            this.currencyCode = _data["currencyCode"];
            this.maxUses = _data["maxUses"];
            this.maxUsesPerCustomer = _data["maxUsesPerCustomer"];
            this.schedule = _data["schedule"] ? PromotionScheduleDto.fromJS(_data["schedule"]) : new PromotionScheduleDto();
            this.conditions = _data["conditions"] ? Conditions.fromJS(_data["conditions"]) : new Conditions();
            this.benefit = _data["benefit"] ? Benefit.fromJS(_data["benefit"]) : undefined as any;
        }
    }

    static fromJS(data: any): PromotionCreateDto {
        data = typeof data === 'object' ? data : {};
        let result = new PromotionCreateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["code"] = this.code;
        data["name"] = this.name;
        data["description"] = this.description;
        data["isStackable"] = this.isStackable;
        data["currencyCode"] = this.currencyCode;
        data["maxUses"] = this.maxUses;
        data["maxUsesPerCustomer"] = this.maxUsesPerCustomer;
        data["schedule"] = this.schedule ? this.schedule.toJSON() : undefined as any;
        data["conditions"] = this.conditions ? this.conditions.toJSON() : undefined as any;
        data["benefit"] = this.benefit ? this.benefit.toJSON() : undefined as any;
        return data;
    }
}

export interface IPromotionCreateDto {
    /** Código único de la promoción. */
    code: string;
    /** Nombre descriptivo de la promoción. */
    name: string;
    /** Descripción detallada de la promoción para el cliente. */
    description?: string;
    /** Indica si la promoción puede combinarse con otras promociones. */
    isStackable: boolean;
    /** Moneda soportada por el sistema. */
    currencyCode: string;
    /** Número máximo de veces que la promoción puede ser usada globalmente. */
    maxUses?: number;
    /** Número máximo de veces que un cliente puede usar esta promoción. */
    maxUsesPerCustomer?: number;
    /** Calendario de vigencia de la promoción. */
    schedule: PromotionScheduleDto;
    /** Condiciones de elegibilidad de la promoción. */
    conditions: Conditions;
    /** Configuración del beneficio de la promoción. */
    benefit?: Benefit;

    [key: string]: any;
}

export class PromotionCreateResponseDto implements IPromotionCreateResponseDto {
    /** Identificador único interno generado para la promoción */
    id!: string;

    [key: string]: any;

    constructor(data?: IPromotionCreateResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): PromotionCreateResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new PromotionCreateResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id;
        return data;
    }
}

export interface IPromotionCreateResponseDto {
    /** Identificador único interno generado para la promoción */
    id: string;

    [key: string]: any;
}

export class PromotionDetailDto implements IPromotionDetailDto {
    /** Identificador único interno de la promoción. */
    id!: string;
    /** Código único de la promoción. */
    code!: string;
    /** Nombre descriptivo de la promoción. */
    name!: string;
    /** Descripción detallada de la promoción para el cliente. */
    description?: string;
    /** Indica si la promoción puede combinarse con otras promociones. */
    isStackable!: boolean;
    /** Moneda soportada por el sistema. */
    currencyCode!: string;
    /** Número máximo de veces que la promoción puede ser usada globalmente. */
    maxUses?: number;
    /** Número máximo de veces que un cliente puede usar esta promoción. */
    maxUsesPerCustomer?: number;
    /** Calendario de vigencia de la promoción. */
    schedule!: PromotionScheduleDto;
    /** Condiciones de elegibilidad de la promoción. */
    conditions!: Conditions;
    /** Configuración del beneficio de la promoción. */
    benefit?: Benefit;

    [key: string]: any;

    constructor(data?: IPromotionDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.schedule = new PromotionScheduleDto();
            this.conditions = new Conditions();
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"];
            this.code = _data["code"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.isStackable = _data["isStackable"];
            this.currencyCode = _data["currencyCode"];
            this.maxUses = _data["maxUses"];
            this.maxUsesPerCustomer = _data["maxUsesPerCustomer"];
            this.schedule = _data["schedule"] ? PromotionScheduleDto.fromJS(_data["schedule"]) : new PromotionScheduleDto();
            this.conditions = _data["conditions"] ? Conditions.fromJS(_data["conditions"]) : new Conditions();
            this.benefit = _data["benefit"] ? Benefit.fromJS(_data["benefit"]) : undefined as any;
        }
    }

    static fromJS(data: any): PromotionDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new PromotionDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id;
        data["code"] = this.code;
        data["name"] = this.name;
        data["description"] = this.description;
        data["isStackable"] = this.isStackable;
        data["currencyCode"] = this.currencyCode;
        data["maxUses"] = this.maxUses;
        data["maxUsesPerCustomer"] = this.maxUsesPerCustomer;
        data["schedule"] = this.schedule ? this.schedule.toJSON() : undefined as any;
        data["conditions"] = this.conditions ? this.conditions.toJSON() : undefined as any;
        data["benefit"] = this.benefit ? this.benefit.toJSON() : undefined as any;
        return data;
    }
}

export interface IPromotionDetailDto {
    /** Identificador único interno de la promoción. */
    id: string;
    /** Código único de la promoción. */
    code: string;
    /** Nombre descriptivo de la promoción. */
    name: string;
    /** Descripción detallada de la promoción para el cliente. */
    description?: string;
    /** Indica si la promoción puede combinarse con otras promociones. */
    isStackable: boolean;
    /** Moneda soportada por el sistema. */
    currencyCode: string;
    /** Número máximo de veces que la promoción puede ser usada globalmente. */
    maxUses?: number;
    /** Número máximo de veces que un cliente puede usar esta promoción. */
    maxUsesPerCustomer?: number;
    /** Calendario de vigencia de la promoción. */
    schedule: PromotionScheduleDto;
    /** Condiciones de elegibilidad de la promoción. */
    conditions: Conditions;
    /** Configuración del beneficio de la promoción. */
    benefit?: Benefit;

    [key: string]: any;
}

export class PromotionUpdateDto implements IPromotionUpdateDto {
    /** Código único de la promoción. */
    code!: string;
    /** Nombre descriptivo de la promoción. */
    name!: string;
    /** Descripción detallada de la promoción para el cliente. */
    description?: string;
    /** Indica si la promoción puede combinarse con otras promociones. */
    isStackable!: boolean;
    /** Moneda soportada por el sistema. */
    currencyCode!: string;
    /** Número máximo de veces que la promoción puede ser usada globalmente. */
    maxUses?: number;
    /** Número máximo de veces que un cliente puede usar esta promoción. */
    maxUsesPerCustomer?: number;
    /** Calendario de vigencia de la promoción. */
    schedule!: PromotionScheduleDto;
    /** Condiciones de elegibilidad de la promoción. */
    conditions!: Conditions;
    /** Configuración del beneficio de la promoción. */
    benefit?: Benefit;

    [key: string]: any;

    constructor(data?: IPromotionUpdateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.schedule = new PromotionScheduleDto();
            this.conditions = new Conditions();
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.code = _data["code"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.isStackable = _data["isStackable"];
            this.currencyCode = _data["currencyCode"];
            this.maxUses = _data["maxUses"];
            this.maxUsesPerCustomer = _data["maxUsesPerCustomer"];
            this.schedule = _data["schedule"] ? PromotionScheduleDto.fromJS(_data["schedule"]) : new PromotionScheduleDto();
            this.conditions = _data["conditions"] ? Conditions.fromJS(_data["conditions"]) : new Conditions();
            this.benefit = _data["benefit"] ? Benefit.fromJS(_data["benefit"]) : undefined as any;
        }
    }

    static fromJS(data: any): PromotionUpdateDto {
        data = typeof data === 'object' ? data : {};
        let result = new PromotionUpdateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["code"] = this.code;
        data["name"] = this.name;
        data["description"] = this.description;
        data["isStackable"] = this.isStackable;
        data["currencyCode"] = this.currencyCode;
        data["maxUses"] = this.maxUses;
        data["maxUsesPerCustomer"] = this.maxUsesPerCustomer;
        data["schedule"] = this.schedule ? this.schedule.toJSON() : undefined as any;
        data["conditions"] = this.conditions ? this.conditions.toJSON() : undefined as any;
        data["benefit"] = this.benefit ? this.benefit.toJSON() : undefined as any;
        return data;
    }
}

export interface IPromotionUpdateDto {
    /** Código único de la promoción. */
    code: string;
    /** Nombre descriptivo de la promoción. */
    name: string;
    /** Descripción detallada de la promoción para el cliente. */
    description?: string;
    /** Indica si la promoción puede combinarse con otras promociones. */
    isStackable: boolean;
    /** Moneda soportada por el sistema. */
    currencyCode: string;
    /** Número máximo de veces que la promoción puede ser usada globalmente. */
    maxUses?: number;
    /** Número máximo de veces que un cliente puede usar esta promoción. */
    maxUsesPerCustomer?: number;
    /** Calendario de vigencia de la promoción. */
    schedule: PromotionScheduleDto;
    /** Condiciones de elegibilidad de la promoción. */
    conditions: Conditions;
    /** Configuración del beneficio de la promoción. */
    benefit?: Benefit;

    [key: string]: any;
}

export class ParsedAssociationRowErrorDto implements IParsedAssociationRowErrorDto {
    /** Número de fila del archivo (1 = header). */
    row!: number;
    /** Motivo por el que la fila no se pudo leer. */
    message!: string;

    [key: string]: any;

    constructor(data?: IParsedAssociationRowErrorDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.row = _data["row"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): ParsedAssociationRowErrorDto {
        data = typeof data === 'object' ? data : {};
        let result = new ParsedAssociationRowErrorDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["row"] = this.row;
        data["message"] = this.message;
        return data;
    }
}

export interface IParsedAssociationRowErrorDto {
    /** Número de fila del archivo (1 = header). */
    row: number;
    /** Motivo por el que la fila no se pudo leer. */
    message: string;

    [key: string]: any;
}

export class ResolvedAssociationDto implements IResolvedAssociationDto {
    /** Valor canónico que la promoción persiste (para SKUs es el skuRefId, para el resto el id de la entidad). */
    id!: string;
    /** Etiqueta legible para mostrar en el selector. */
    label!: string;
    /** ID tal como vino en el request, cuando difiere del canónico (ej: se envió un skuId y se resolvió a skuRefId). */
    requestedId?: string;

    [key: string]: any;

    constructor(data?: IResolvedAssociationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"];
            this.label = _data["label"];
            this.requestedId = _data["requestedId"];
        }
    }

    static fromJS(data: any): ResolvedAssociationDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResolvedAssociationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id;
        data["label"] = this.label;
        data["requestedId"] = this.requestedId;
        return data;
    }
}

export interface IResolvedAssociationDto {
    /** Valor canónico que la promoción persiste (para SKUs es el skuRefId, para el resto el id de la entidad). */
    id: string;
    /** Etiqueta legible para mostrar en el selector. */
    label: string;
    /** ID tal como vino en el request, cuando difiere del canónico (ej: se envió un skuId y se resolvió a skuRefId). */
    requestedId?: string;

    [key: string]: any;
}

export class ResolveAssociationErrorDto implements IResolveAssociationErrorDto {
    /** ID del request que no se pudo resolver. */
    id!: string;
    /** Código de error (CATEGORY_NOT_FOUND, BRAND_NOT_FOUND, SKU_NOT_FOUND, COLLECTION_NOT_FOUND, PRODUCT_NOT_FOUND, SELLER_NOT_FOUND, ROW_PROCESS_ERROR). */
    code!: string;
    message!: string;

    [key: string]: any;

    constructor(data?: IResolveAssociationErrorDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"];
            this.code = _data["code"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): ResolveAssociationErrorDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResolveAssociationErrorDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id;
        data["code"] = this.code;
        data["message"] = this.message;
        return data;
    }
}

export interface IResolveAssociationErrorDto {
    /** ID del request que no se pudo resolver. */
    id: string;
    /** Código de error (CATEGORY_NOT_FOUND, BRAND_NOT_FOUND, SKU_NOT_FOUND, COLLECTION_NOT_FOUND, PRODUCT_NOT_FOUND, SELLER_NOT_FOUND, ROW_PROCESS_ERROR). */
    code: string;
    message: string;

    [key: string]: any;
}

export class PromotionDto implements IPromotionDto {
    id!: string;
    code!: string;
    name!: string;
    description?: string;
    isStackable!: boolean;
    currencyCode!: PromotionDtoCurrencyCode;
    status!: PromotionDtoStatus;
    benefitType!: PromotionDtoBenefitType;
    schedule!: PromotionScheduleDto;

    [key: string]: any;

    constructor(data?: IPromotionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.schedule = new PromotionScheduleDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"];
            this.code = _data["code"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.isStackable = _data["isStackable"];
            this.currencyCode = _data["currencyCode"];
            this.status = _data["status"];
            this.benefitType = _data["benefitType"];
            this.schedule = _data["schedule"] ? PromotionScheduleDto.fromJS(_data["schedule"]) : new PromotionScheduleDto();
        }
    }

    static fromJS(data: any): PromotionDto {
        data = typeof data === 'object' ? data : {};
        let result = new PromotionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id;
        data["code"] = this.code;
        data["name"] = this.name;
        data["description"] = this.description;
        data["isStackable"] = this.isStackable;
        data["currencyCode"] = this.currencyCode;
        data["status"] = this.status;
        data["benefitType"] = this.benefitType;
        data["schedule"] = this.schedule ? this.schedule.toJSON() : undefined as any;
        return data;
    }
}

export interface IPromotionDto {
    id: string;
    code: string;
    name: string;
    description?: string;
    isStackable: boolean;
    currencyCode: PromotionDtoCurrencyCode;
    status: PromotionDtoStatus;
    benefitType: PromotionDtoBenefitType;
    schedule: PromotionScheduleDto;

    [key: string]: any;
}

export class PageableDto implements IPageableDto {
    pageNumber!: number;
    pageSize!: number;
    offset!: number;
    paged!: boolean;
    unpaged!: boolean;
    sort!: SortDto;

    [key: string]: any;

    constructor(data?: IPageableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.sort = new SortDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.offset = _data["offset"];
            this.paged = _data["paged"];
            this.unpaged = _data["unpaged"];
            this.sort = _data["sort"] ? SortDto.fromJS(_data["sort"]) : new SortDto();
        }
    }

    static fromJS(data: any): PageableDto {
        data = typeof data === 'object' ? data : {};
        let result = new PageableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["offset"] = this.offset;
        data["paged"] = this.paged;
        data["unpaged"] = this.unpaged;
        data["sort"] = this.sort ? this.sort.toJSON() : undefined as any;
        return data;
    }
}

export interface IPageableDto {
    pageNumber: number;
    pageSize: number;
    offset: number;
    paged: boolean;
    unpaged: boolean;
    sort: SortDto;

    [key: string]: any;
}

export class SortDto implements ISortDto {
    empty!: boolean;
    sorted!: boolean;
    unsorted!: boolean;

    [key: string]: any;

    constructor(data?: ISortDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.empty = _data["empty"];
            this.sorted = _data["sorted"];
            this.unsorted = _data["unsorted"];
        }
    }

    static fromJS(data: any): SortDto {
        data = typeof data === 'object' ? data : {};
        let result = new SortDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["empty"] = this.empty;
        data["sorted"] = this.sorted;
        data["unsorted"] = this.unsorted;
        return data;
    }
}

export interface ISortDto {
    empty: boolean;
    sorted: boolean;
    unsorted: boolean;

    [key: string]: any;
}

export class PromotionScheduleDto implements IPromotionScheduleDto {
    startDate!: Date;
    endDate?: Date;

    [key: string]: any;

    constructor(data?: IPromotionScheduleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : undefined as any;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): PromotionScheduleDto {
        data = typeof data === 'object' ? data : {};
        let result = new PromotionScheduleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["startDate"] = this.startDate ? this.startDate.toISOString() : undefined as any;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : undefined as any;
        return data;
    }
}

export interface IPromotionScheduleDto {
    startDate: Date;
    endDate?: Date;

    [key: string]: any;
}

export class Conditions implements IConditions {
    /** Condición de contexto de venta para creación. */
    salesContext?: SalesContext;
    /** Condición de cliente para creación. */
    customer?: CustomerCondition;
    /** Condición de items del carrito. */
    cartItem?: CartItemCondition;
    /** Condición del carrito total para creación. */
    cart?: CartCondition;
    /** Condición de forma de pago para creación. */
    payment?: PaymentCondition;
    /** Condición de envío para creación. */
    shipping?: ShippingCondition;
    /** Condición de cupón para creación. */
    coupon?: CouponCondition;

    [key: string]: any;

    constructor(data?: IConditions) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.salesContext = _data["salesContext"] ? SalesContext.fromJS(_data["salesContext"]) : undefined as any;
            this.customer = _data["customer"] ? CustomerCondition.fromJS(_data["customer"]) : undefined as any;
            this.cartItem = _data["cartItem"] ? CartItemCondition.fromJS(_data["cartItem"]) : undefined as any;
            this.cart = _data["cart"] ? CartCondition.fromJS(_data["cart"]) : undefined as any;
            this.payment = _data["payment"] ? PaymentCondition.fromJS(_data["payment"]) : undefined as any;
            this.shipping = _data["shipping"] ? ShippingCondition.fromJS(_data["shipping"]) : undefined as any;
            this.coupon = _data["coupon"] ? CouponCondition.fromJS(_data["coupon"]) : undefined as any;
        }
    }

    static fromJS(data: any): Conditions {
        data = typeof data === 'object' ? data : {};
        let result = new Conditions();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["salesContext"] = this.salesContext ? this.salesContext.toJSON() : undefined as any;
        data["customer"] = this.customer ? this.customer.toJSON() : undefined as any;
        data["cartItem"] = this.cartItem ? this.cartItem.toJSON() : undefined as any;
        data["cart"] = this.cart ? this.cart.toJSON() : undefined as any;
        data["payment"] = this.payment ? this.payment.toJSON() : undefined as any;
        data["shipping"] = this.shipping ? this.shipping.toJSON() : undefined as any;
        data["coupon"] = this.coupon ? this.coupon.toJSON() : undefined as any;
        return data;
    }
}

export interface IConditions {
    /** Condición de contexto de venta para creación. */
    salesContext?: SalesContext;
    /** Condición de cliente para creación. */
    customer?: CustomerCondition;
    /** Condición de items del carrito. */
    cartItem?: CartItemCondition;
    /** Condición del carrito total para creación. */
    cart?: CartCondition;
    /** Condición de forma de pago para creación. */
    payment?: PaymentCondition;
    /** Condición de envío para creación. */
    shipping?: ShippingCondition;
    /** Condición de cupón para creación. */
    coupon?: CouponCondition;

    [key: string]: any;
}

export class Benefit implements IBenefit {
    /** Tipo de beneficio que otorga la promoción. */
    type!: BenefitType;
    /** Porcentaje de descuento a aplicar (0-100). Solo para PERCENTAGE_DISCOUNT. */
    percentage?: number;
    /** Tope máximo del descuento por item. Solo para PERCENTAGE_DISCOUNT. */
    maxDiscountPerItem?: number;
    /** Tope máximo del descuento total de la promoción. Solo para PERCENTAGE_DISCOUNT. */
    maxDiscount?: number;
    /** Monto fijo de descuento a aplicar. Solo para FIXED_DISCOUNT. */
    discountAmount?: number;
    /** Nuevo precio fijo para el producto. Solo para FIXED_PRICE. */
    newPrice?: number;
    /** Cantidad de productos de regalo a otorgar. Solo para GIFT. */
    giftQuantity?: number;
    /** Lista de SKUs disponibles como regalo. Solo para GIFT. */
    giftSkus?: string[];
    /** Cantidad de unidades a comprar. Solo para MXN. */
    buyQuantity?: number;
    /** Cantidad de unidades a pagar. Solo para MXN. */
    payQuantity?: number;
    /** Indica si se pueden mezclar diferentes SKUs para cumplir la cantidad. Solo para MXN y PROGRESSIVE_DISCOUNT. */
    allowMixedSkus?: boolean;
    /** Tipo de valor de descuento. Solo para PROGRESSIVE_DISCOUNT. */
    discountValueType?: BenefitDiscountValueType;
    /** Lista de tiers de descuento progresivo. Solo para PROGRESSIVE_DISCOUNT. */
    progressiveTiers?: ProgressiveTier[];
    /** Indica si el beneficio se aplica a nivel de producto individual. Para PERCENTAGE_DISCOUNT, FIXED_DISCOUNT, FIXED_PRICE, MXN. */
    productLevel?: boolean;
    /** Cantidad mínima de unidades que debe comprar el cliente para ser elegible. Solo para MORE_FOR_LESS. */
    requiredQuantity?: number;
    /** Cantidad de unidades que recibirán el descuento. Solo para MORE_FOR_LESS. */
    discountQuantity?: number;
    /** Valor del descuento a aplicar en las unidades seleccionadas. Formato depende de discountValueType. Solo para MORE_FOR_LESS. */
    discountValue?: number;
    /** Estrategia para tomar los items al aplicar el beneficio. */
    sortingStrategy?: BenefitSortingStrategy;
    /** Indica si el descuento debe distribuirse entre los items elegibles o aplicarse específicamente. Solo para MORE_FOR_LESS. */
    distributeDiscount?: boolean;
    /** Cantidad mínima de unidades de Lista 1 (productos disparadores) requerida para activar el bundle. Solo para BUNDLE. */
    triggerQuantity?: number;
    /** Precio fijo aplicado a cada unidad de los productos disparadores (Lista 1). Al menos uno de triggerFixedPrice o benefitFixedPrice debe tener un valor. Solo para BUNDLE. */
    triggerFixedPrice?: number;
    /** Lista de SKUs que pertenecen a Lista 2 (productos de beneficio). Estos SKUs siempre reciben el beneficio cuando la promoción se activa. Solo para BUNDLE. */
    benefitSkus?: string[];
    /** Precio fijo aplicado a cada unidad de los productos de beneficio (Lista 2). Al menos uno de triggerFixedPrice o benefitFixedPrice debe tener un valor. Solo para BUNDLE. */
    benefitFixedPrice?: number;

    [key: string]: any;

    constructor(data?: IBenefit) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.type = _data["type"];
            this.percentage = _data["percentage"];
            this.maxDiscountPerItem = _data["maxDiscountPerItem"];
            this.maxDiscount = _data["maxDiscount"];
            this.discountAmount = _data["discountAmount"];
            this.newPrice = _data["newPrice"];
            this.giftQuantity = _data["giftQuantity"];
            if (Array.isArray(_data["giftSkus"])) {
                this.giftSkus = [] as any;
                for (let item of _data["giftSkus"])
                    this.giftSkus!.push(item);
            }
            this.buyQuantity = _data["buyQuantity"];
            this.payQuantity = _data["payQuantity"];
            this.allowMixedSkus = _data["allowMixedSkus"];
            this.discountValueType = _data["discountValueType"];
            if (Array.isArray(_data["progressiveTiers"])) {
                this.progressiveTiers = [] as any;
                for (let item of _data["progressiveTiers"])
                    this.progressiveTiers!.push(ProgressiveTier.fromJS(item));
            }
            this.productLevel = _data["productLevel"];
            this.requiredQuantity = _data["requiredQuantity"];
            this.discountQuantity = _data["discountQuantity"];
            this.discountValue = _data["discountValue"];
            this.sortingStrategy = _data["sortingStrategy"];
            this.distributeDiscount = _data["distributeDiscount"];
            this.triggerQuantity = _data["triggerQuantity"];
            this.triggerFixedPrice = _data["triggerFixedPrice"];
            if (Array.isArray(_data["benefitSkus"])) {
                this.benefitSkus = [] as any;
                for (let item of _data["benefitSkus"])
                    this.benefitSkus!.push(item);
            }
            this.benefitFixedPrice = _data["benefitFixedPrice"];
        }
    }

    static fromJS(data: any): Benefit {
        data = typeof data === 'object' ? data : {};
        let result = new Benefit();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["type"] = this.type;
        data["percentage"] = this.percentage;
        data["maxDiscountPerItem"] = this.maxDiscountPerItem;
        data["maxDiscount"] = this.maxDiscount;
        data["discountAmount"] = this.discountAmount;
        data["newPrice"] = this.newPrice;
        data["giftQuantity"] = this.giftQuantity;
        if (Array.isArray(this.giftSkus)) {
            data["giftSkus"] = [];
            for (let item of this.giftSkus)
                data["giftSkus"].push(item);
        }
        data["buyQuantity"] = this.buyQuantity;
        data["payQuantity"] = this.payQuantity;
        data["allowMixedSkus"] = this.allowMixedSkus;
        data["discountValueType"] = this.discountValueType;
        if (Array.isArray(this.progressiveTiers)) {
            data["progressiveTiers"] = [];
            for (let item of this.progressiveTiers)
                data["progressiveTiers"].push(item ? item.toJSON() : undefined as any);
        }
        data["productLevel"] = this.productLevel;
        data["requiredQuantity"] = this.requiredQuantity;
        data["discountQuantity"] = this.discountQuantity;
        data["discountValue"] = this.discountValue;
        data["sortingStrategy"] = this.sortingStrategy;
        data["distributeDiscount"] = this.distributeDiscount;
        data["triggerQuantity"] = this.triggerQuantity;
        data["triggerFixedPrice"] = this.triggerFixedPrice;
        if (Array.isArray(this.benefitSkus)) {
            data["benefitSkus"] = [];
            for (let item of this.benefitSkus)
                data["benefitSkus"].push(item);
        }
        data["benefitFixedPrice"] = this.benefitFixedPrice;
        return data;
    }
}

export interface IBenefit {
    /** Tipo de beneficio que otorga la promoción. */
    type: BenefitType;
    /** Porcentaje de descuento a aplicar (0-100). Solo para PERCENTAGE_DISCOUNT. */
    percentage?: number;
    /** Tope máximo del descuento por item. Solo para PERCENTAGE_DISCOUNT. */
    maxDiscountPerItem?: number;
    /** Tope máximo del descuento total de la promoción. Solo para PERCENTAGE_DISCOUNT. */
    maxDiscount?: number;
    /** Monto fijo de descuento a aplicar. Solo para FIXED_DISCOUNT. */
    discountAmount?: number;
    /** Nuevo precio fijo para el producto. Solo para FIXED_PRICE. */
    newPrice?: number;
    /** Cantidad de productos de regalo a otorgar. Solo para GIFT. */
    giftQuantity?: number;
    /** Lista de SKUs disponibles como regalo. Solo para GIFT. */
    giftSkus?: string[];
    /** Cantidad de unidades a comprar. Solo para MXN. */
    buyQuantity?: number;
    /** Cantidad de unidades a pagar. Solo para MXN. */
    payQuantity?: number;
    /** Indica si se pueden mezclar diferentes SKUs para cumplir la cantidad. Solo para MXN y PROGRESSIVE_DISCOUNT. */
    allowMixedSkus?: boolean;
    /** Tipo de valor de descuento. Solo para PROGRESSIVE_DISCOUNT. */
    discountValueType?: BenefitDiscountValueType;
    /** Lista de tiers de descuento progresivo. Solo para PROGRESSIVE_DISCOUNT. */
    progressiveTiers?: ProgressiveTier[];
    /** Indica si el beneficio se aplica a nivel de producto individual. Para PERCENTAGE_DISCOUNT, FIXED_DISCOUNT, FIXED_PRICE, MXN. */
    productLevel?: boolean;
    /** Cantidad mínima de unidades que debe comprar el cliente para ser elegible. Solo para MORE_FOR_LESS. */
    requiredQuantity?: number;
    /** Cantidad de unidades que recibirán el descuento. Solo para MORE_FOR_LESS. */
    discountQuantity?: number;
    /** Valor del descuento a aplicar en las unidades seleccionadas. Formato depende de discountValueType. Solo para MORE_FOR_LESS. */
    discountValue?: number;
    /** Estrategia para tomar los items al aplicar el beneficio. */
    sortingStrategy?: BenefitSortingStrategy;
    /** Indica si el descuento debe distribuirse entre los items elegibles o aplicarse específicamente. Solo para MORE_FOR_LESS. */
    distributeDiscount?: boolean;
    /** Cantidad mínima de unidades de Lista 1 (productos disparadores) requerida para activar el bundle. Solo para BUNDLE. */
    triggerQuantity?: number;
    /** Precio fijo aplicado a cada unidad de los productos disparadores (Lista 1). Al menos uno de triggerFixedPrice o benefitFixedPrice debe tener un valor. Solo para BUNDLE. */
    triggerFixedPrice?: number;
    /** Lista de SKUs que pertenecen a Lista 2 (productos de beneficio). Estos SKUs siempre reciben el beneficio cuando la promoción se activa. Solo para BUNDLE. */
    benefitSkus?: string[];
    /** Precio fijo aplicado a cada unidad de los productos de beneficio (Lista 2). Al menos uno de triggerFixedPrice o benefitFixedPrice debe tener un valor. Solo para BUNDLE. */
    benefitFixedPrice?: number;

    [key: string]: any;
}

export class SalesContext implements ISalesContext {
    /** Identificadores de contextos de venta donde aplica la promoción. */
    ids?: string[];
    /** Canales de venta donde aplica la promoción. */
    channels?: Channels[];

    [key: string]: any;

    constructor(data?: ISalesContext) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["ids"])) {
                this.ids = [] as any;
                for (let item of _data["ids"])
                    this.ids!.push(item);
            }
            if (Array.isArray(_data["channels"])) {
                this.channels = [] as any;
                for (let item of _data["channels"])
                    this.channels!.push(item);
            }
        }
    }

    static fromJS(data: any): SalesContext {
        data = typeof data === 'object' ? data : {};
        let result = new SalesContext();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.ids)) {
            data["ids"] = [];
            for (let item of this.ids)
                data["ids"].push(item);
        }
        if (Array.isArray(this.channels)) {
            data["channels"] = [];
            for (let item of this.channels)
                data["channels"].push(item);
        }
        return data;
    }
}

export interface ISalesContext {
    /** Identificadores de contextos de venta donde aplica la promoción. */
    ids?: string[];
    /** Canales de venta donde aplica la promoción. */
    channels?: Channels[];

    [key: string]: any;
}

export class CustomerCondition implements ICustomerCondition {
    /** Identificadores específicos de clientes elegibles. */
    ids?: string[];
    /** Segmentos o clusters de clientes elegibles. */
    clusters?: string[];
    /** Indica si aplica solo para la primera compra. */
    isFirstPurchase?: boolean;

    [key: string]: any;

    constructor(data?: ICustomerCondition) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["ids"])) {
                this.ids = [] as any;
                for (let item of _data["ids"])
                    this.ids!.push(item);
            }
            if (Array.isArray(_data["clusters"])) {
                this.clusters = [] as any;
                for (let item of _data["clusters"])
                    this.clusters!.push(item);
            }
            this.isFirstPurchase = _data["isFirstPurchase"];
        }
    }

    static fromJS(data: any): CustomerCondition {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerCondition();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.ids)) {
            data["ids"] = [];
            for (let item of this.ids)
                data["ids"].push(item);
        }
        if (Array.isArray(this.clusters)) {
            data["clusters"] = [];
            for (let item of this.clusters)
                data["clusters"].push(item);
        }
        data["isFirstPurchase"] = this.isFirstPurchase;
        return data;
    }
}

export interface ICustomerCondition {
    /** Identificadores específicos de clientes elegibles. */
    ids?: string[];
    /** Segmentos o clusters de clientes elegibles. */
    clusters?: string[];
    /** Indica si aplica solo para la primera compra. */
    isFirstPurchase?: boolean;

    [key: string]: any;
}

export class CartItemCondition implements ICartItemCondition {
    /** Categorías de productos elegibles o excluidas. */
    categories?: string[];
    /** Marcas elegibles o excluidas. */
    brands?: string[];
    /** SKUs elegibles o excluidos. */
    skus?: string[];
    /** Productos elegibles o excluidos, identificados por productRefId. */
    productIds?: string[];
    /** Etiquetas de productos elegibles o excluidas. */
    tags?: string[];
    /** Sellers elegibles o excluidos, identificados por su sellerId del marketplace. */
    sellers?: string[];
    /** Monto mínimo de compra de los items que cumplen estas condiciones. */
    minPurchaseAmount?: number;
    /** Monto máximo de compra de los items que cumplen estas condiciones. */
    maxPurchaseAmount?: number;

    [key: string]: any;

    constructor(data?: ICartItemCondition) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["categories"])) {
                this.categories = [] as any;
                for (let item of _data["categories"])
                    this.categories!.push(item);
            }
            if (Array.isArray(_data["brands"])) {
                this.brands = [] as any;
                for (let item of _data["brands"])
                    this.brands!.push(item);
            }
            if (Array.isArray(_data["skus"])) {
                this.skus = [] as any;
                for (let item of _data["skus"])
                    this.skus!.push(item);
            }
            if (Array.isArray(_data["productIds"])) {
                this.productIds = [] as any;
                for (let item of _data["productIds"])
                    this.productIds!.push(item);
            }
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(item);
            }
            if (Array.isArray(_data["sellers"])) {
                this.sellers = [] as any;
                for (let item of _data["sellers"])
                    this.sellers!.push(item);
            }
            this.minPurchaseAmount = _data["minPurchaseAmount"];
            this.maxPurchaseAmount = _data["maxPurchaseAmount"];
        }
    }

    static fromJS(data: any): CartItemCondition {
        data = typeof data === 'object' ? data : {};
        let result = new CartItemCondition();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.categories)) {
            data["categories"] = [];
            for (let item of this.categories)
                data["categories"].push(item);
        }
        if (Array.isArray(this.brands)) {
            data["brands"] = [];
            for (let item of this.brands)
                data["brands"].push(item);
        }
        if (Array.isArray(this.skus)) {
            data["skus"] = [];
            for (let item of this.skus)
                data["skus"].push(item);
        }
        if (Array.isArray(this.productIds)) {
            data["productIds"] = [];
            for (let item of this.productIds)
                data["productIds"].push(item);
        }
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item);
        }
        if (Array.isArray(this.sellers)) {
            data["sellers"] = [];
            for (let item of this.sellers)
                data["sellers"].push(item);
        }
        data["minPurchaseAmount"] = this.minPurchaseAmount;
        data["maxPurchaseAmount"] = this.maxPurchaseAmount;
        return data;
    }
}

export interface ICartItemCondition {
    /** Categorías de productos elegibles o excluidas. */
    categories?: string[];
    /** Marcas elegibles o excluidas. */
    brands?: string[];
    /** SKUs elegibles o excluidos. */
    skus?: string[];
    /** Productos elegibles o excluidos, identificados por productRefId. */
    productIds?: string[];
    /** Etiquetas de productos elegibles o excluidas. */
    tags?: string[];
    /** Sellers elegibles o excluidos, identificados por su sellerId del marketplace. */
    sellers?: string[];
    /** Monto mínimo de compra de los items que cumplen estas condiciones. */
    minPurchaseAmount?: number;
    /** Monto máximo de compra de los items que cumplen estas condiciones. */
    maxPurchaseAmount?: number;

    [key: string]: any;
}

export class CartCondition implements ICartCondition {
    /** Monto mínimo del carrito total para que aplique la promoción. */
    minPurchaseAmount?: number;
    /** Monto máximo del carrito total para que aplique la promoción. */
    maxPurchaseAmount?: number;
    /** Cantidad mínima de items en el carrito. */
    minTotalItems?: number;
    /** Cantidad máxima de items en el carrito. */
    maxTotalItems?: number;

    [key: string]: any;

    constructor(data?: ICartCondition) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.minPurchaseAmount = _data["minPurchaseAmount"];
            this.maxPurchaseAmount = _data["maxPurchaseAmount"];
            this.minTotalItems = _data["minTotalItems"];
            this.maxTotalItems = _data["maxTotalItems"];
        }
    }

    static fromJS(data: any): CartCondition {
        data = typeof data === 'object' ? data : {};
        let result = new CartCondition();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["minPurchaseAmount"] = this.minPurchaseAmount;
        data["maxPurchaseAmount"] = this.maxPurchaseAmount;
        data["minTotalItems"] = this.minTotalItems;
        data["maxTotalItems"] = this.maxTotalItems;
        return data;
    }
}

export interface ICartCondition {
    /** Monto mínimo del carrito total para que aplique la promoción. */
    minPurchaseAmount?: number;
    /** Monto máximo del carrito total para que aplique la promoción. */
    maxPurchaseAmount?: number;
    /** Cantidad mínima de items en el carrito. */
    minTotalItems?: number;
    /** Cantidad máxima de items en el carrito. */
    maxTotalItems?: number;

    [key: string]: any;
}

export class PaymentCondition implements IPaymentCondition {
    /** Métodos de pago elegibles. */
    paymentMethods?: string[];
    /** Marcas de tarjetas elegibles. */
    cardBrands?: string[];
    /** Indica si se requieren cuotas para aplicar la promoción. */
    areInstallmentsRequired?: boolean;
    /** Número mínimo de cuotas requerido. */
    minInstallments?: number;

    [key: string]: any;

    constructor(data?: IPaymentCondition) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["paymentMethods"])) {
                this.paymentMethods = [] as any;
                for (let item of _data["paymentMethods"])
                    this.paymentMethods!.push(item);
            }
            if (Array.isArray(_data["cardBrands"])) {
                this.cardBrands = [] as any;
                for (let item of _data["cardBrands"])
                    this.cardBrands!.push(item);
            }
            this.areInstallmentsRequired = _data["areInstallmentsRequired"];
            this.minInstallments = _data["minInstallments"];
        }
    }

    static fromJS(data: any): PaymentCondition {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentCondition();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.paymentMethods)) {
            data["paymentMethods"] = [];
            for (let item of this.paymentMethods)
                data["paymentMethods"].push(item);
        }
        if (Array.isArray(this.cardBrands)) {
            data["cardBrands"] = [];
            for (let item of this.cardBrands)
                data["cardBrands"].push(item);
        }
        data["areInstallmentsRequired"] = this.areInstallmentsRequired;
        data["minInstallments"] = this.minInstallments;
        return data;
    }
}

export interface IPaymentCondition {
    /** Métodos de pago elegibles. */
    paymentMethods?: string[];
    /** Marcas de tarjetas elegibles. */
    cardBrands?: string[];
    /** Indica si se requieren cuotas para aplicar la promoción. */
    areInstallmentsRequired?: boolean;
    /** Número mínimo de cuotas requerido. */
    minInstallments?: number;

    [key: string]: any;
}

export class ShippingCondition implements IShippingCondition {
    /** Códigos ISO de países donde aplica la promoción. */
    countryCodes?: string[];
    /** Códigos UBIGEO (6 dígitos) donde aplica la promoción. */
    ubigeoCodes?: string[];
    /** Zonas de envío donde aplica la promoción. */
    zones?: string[];

    [key: string]: any;

    constructor(data?: IShippingCondition) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["countryCodes"])) {
                this.countryCodes = [] as any;
                for (let item of _data["countryCodes"])
                    this.countryCodes!.push(item);
            }
            if (Array.isArray(_data["ubigeoCodes"])) {
                this.ubigeoCodes = [] as any;
                for (let item of _data["ubigeoCodes"])
                    this.ubigeoCodes!.push(item);
            }
            if (Array.isArray(_data["zones"])) {
                this.zones = [] as any;
                for (let item of _data["zones"])
                    this.zones!.push(item);
            }
        }
    }

    static fromJS(data: any): ShippingCondition {
        data = typeof data === 'object' ? data : {};
        let result = new ShippingCondition();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.countryCodes)) {
            data["countryCodes"] = [];
            for (let item of this.countryCodes)
                data["countryCodes"].push(item);
        }
        if (Array.isArray(this.ubigeoCodes)) {
            data["ubigeoCodes"] = [];
            for (let item of this.ubigeoCodes)
                data["ubigeoCodes"].push(item);
        }
        if (Array.isArray(this.zones)) {
            data["zones"] = [];
            for (let item of this.zones)
                data["zones"].push(item);
        }
        return data;
    }
}

export interface IShippingCondition {
    /** Códigos ISO de países donde aplica la promoción. */
    countryCodes?: string[];
    /** Códigos UBIGEO (6 dígitos) donde aplica la promoción. */
    ubigeoCodes?: string[];
    /** Zonas de envío donde aplica la promoción. */
    zones?: string[];

    [key: string]: any;
}

export class CouponCondition implements ICouponCondition {
    /** Código de cupón que debe ser ingresado para activar la promoción. */
    code?: string;

    [key: string]: any;

    constructor(data?: ICouponCondition) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): CouponCondition {
        data = typeof data === 'object' ? data : {};
        let result = new CouponCondition();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["code"] = this.code;
        return data;
    }
}

export interface ICouponCondition {
    /** Código de cupón que debe ser ingresado para activar la promoción. */
    code?: string;

    [key: string]: any;
}

export class ProgressiveTier implements IProgressiveTier {
    /** Cantidad mínima de unidades para que aplique este descuento. */
    minQuantity!: number;
    /** Valor del descuento en este tier. Depende de discountValueType. */
    discountValue!: number;

    [key: string]: any;

    constructor(data?: IProgressiveTier) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.minQuantity = _data["minQuantity"];
            this.discountValue = _data["discountValue"];
        }
    }

    static fromJS(data: any): ProgressiveTier {
        data = typeof data === 'object' ? data : {};
        let result = new ProgressiveTier();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["minQuantity"] = this.minQuantity;
        data["discountValue"] = this.discountValue;
        return data;
    }
}

export interface IProgressiveTier {
    /** Cantidad mínima de unidades para que aplique este descuento. */
    minQuantity: number;
    /** Valor del descuento en este tier. Depende de discountValueType. */
    discountValue: number;

    [key: string]: any;
}

export enum Status {
    READY = "READY",
    FINISHED = "FINISHED",
}

export enum Types {
    PERCENTAGE_DISCOUNT = "PERCENTAGE_DISCOUNT",
    FIXED_DISCOUNT = "FIXED_DISCOUNT",
    FIXED_PRICE = "FIXED_PRICE",
    GIFT = "GIFT",
    FREE_SHIPPING = "FREE_SHIPPING",
    MXN = "MXN",
    PROGRESSIVE_DISCOUNT = "PROGRESSIVE_DISCOUNT",
    MORE_FOR_LESS = "MORE_FOR_LESS",
    BUNDLE = "BUNDLE",
}

export enum ResolveAssociationsRequestDtoEntityType {
    Categories = "categories",
    Brands = "brands",
    Skus = "skus",
    Collections = "collections",
    Products = "products",
    Sellers = "sellers",
}

export enum PromotionFinishDtoReason {
    SOLD_OUT = "SOLD_OUT",
    EXPIRED = "EXPIRED",
    CANCELLED = "CANCELLED",
}

export enum PromotionDtoCurrencyCode {
    USD = "USD",
    PEN = "PEN",
}

export enum PromotionDtoStatus {
    READY = "READY",
    FINISHED = "FINISHED",
}

export enum PromotionDtoBenefitType {
    PERCENTAGE_DISCOUNT = "PERCENTAGE_DISCOUNT",
    FIXED_DISCOUNT = "FIXED_DISCOUNT",
    FIXED_PRICE = "FIXED_PRICE",
    GIFT = "GIFT",
    FREE_SHIPPING = "FREE_SHIPPING",
    MXN = "MXN",
    PROGRESSIVE_DISCOUNT = "PROGRESSIVE_DISCOUNT",
    MORE_FOR_LESS = "MORE_FOR_LESS",
    BUNDLE = "BUNDLE",
}

export enum BenefitType {
    PERCENTAGE_DISCOUNT = "PERCENTAGE_DISCOUNT",
    FIXED_DISCOUNT = "FIXED_DISCOUNT",
    FIXED_PRICE = "FIXED_PRICE",
    GIFT = "GIFT",
    FREE_SHIPPING = "FREE_SHIPPING",
    MXN = "MXN",
    PROGRESSIVE_DISCOUNT = "PROGRESSIVE_DISCOUNT",
    MORE_FOR_LESS = "MORE_FOR_LESS",
    BUNDLE = "BUNDLE",
}

export enum BenefitDiscountValueType {
    PERCENTAGE = "PERCENTAGE",
    FIXED_PRICE = "FIXED_PRICE",
}

export enum BenefitSortingStrategy {
    CHEAPEST = "CHEAPEST",
    MOST_EXPENSIVE = "MOST_EXPENSIVE",
}

export enum Channels {
    AppMobile = "appMobile",
    Web = "web",
    Store = "store",
    Marketplace = "marketplace",
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export class ApiException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new ApiException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((event.target as any).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}